import { Module } from "vuex";
import { jobsProfileState, initialState } from "./state";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";

const jobsProfileStore: Module<any, jobsProfileState> = {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};

export default jobsProfileStore;
